
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iniciativas/gira",
      function () {
        return require("private-next-pages/iniciativas/gira.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iniciativas/gira"])
      });
    }
  